import type { ClientContactRow, ClientContactRowDto } from '../types';

export function clientContactRowFromDto(
  row: ClientContactRowDto,
): ClientContactRow {
  return {
    id: row.id,
    contact: row.contact,
    functionTitle: row.function_title,
    role: row.role,
    start: row.start,
    end: row.end,
    rights: row.rights,
    officeAddressUsageId: row.office_address_usage,
    employers: row.employers ?? [],
  };
}
